var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"debug",on:{"click":function($event){_vm.visible = false}}},[_c('span',[_vm._v(_vm._s(_vm.env))]),(_vm.env !== 'dev')?_c('span',[_vm._v(" | 构建时间: "+_vm._s(_vm.buildTime))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }